import React, { useState } from "react";
import {  X } from "lucide-react";

// Import all gallery images from the correct path
import image2 from "../../assets/images/gallery/1.webp";
import image13 from "../../assets/images/gallery/2.webp";
import image6 from "../../assets/images/gallery/3.webp";
import image4 from "../../assets/images/gallery/4.webp";
import image5 from "../../assets/images/gallery/5.webp";
import image3 from "../../assets/images/gallery/6.webp";
import image7 from "../../assets/images/gallery/7.webp";
import image8 from "../../assets/images/gallery/8.webp";
import image9 from "../../assets/images/gallery/9.webp";
import image10 from "../../assets/images/gallery/10.webp";
import image11 from "../../assets/images/gallery/11.webp";
import image12 from "../../assets/images/gallery/12.webp";
import image1 from "../../assets/images/gallery/13.webp";

const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [showLightbox, setShowLightbox] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoading, setIsLoading] = useState(false);

  const displayedImages = images.slice(0, visibleCount);
  const hasMoreImages = visibleCount < images.length;

  const handleImageClick = (index: number) => {
    setSelectedImage(index);
    setShowLightbox(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setShowLightbox(false);
    setSelectedImage(null);
    document.body.style.overflow = "unset";
  };

  return (
    <section
      className="relative py-14 md:py-18 px-6 md:px-12 lg:px-24
      bg-gradient-to-b from-white via-[#F8FAFC] to-white overflow-hidden"
    >
      {/* subtle brand background */}
      <div className="absolute inset-x-0 top-40 h-[420px] bg-[#0E6F7E]/5 blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>

          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#07162E] mb-4">
            Glimpse of Last Summit
          </h2>

          <h3 className="  text-[#07162E] mb-2"> In T-Hub, Hyderabad </h3>
          

          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See highlights from our previous events and prepare for an even more
            immersive experience this year.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedImages.map((src, index) => (
            <div
              key={index}
              onClick={() => handleImageClick(index)}
              className="group cursor-pointer overflow-hidden rounded-2xl
              bg-white shadow-[0_20px_50px_rgba(2,8,23,0.12)]
              hover:shadow-[0_30px_70px_rgba(2,8,23,0.18)]
              transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={src}
                  alt={`Summit ${index + 1}`}
                  className="w-full h-full object-cover
                  transform group-hover:scale-105 transition-transform duration-700"
                />

                {/* Institutional overlay */}
                <div
                  className="absolute inset-0 bg-gradient-to-t
                  from-[#07162E]/70 via-[#07162E]/20 to-transparent
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />

                {/* Gold accent line */}
                <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-[#D4AF37] to-[#C9A631] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </div>
          ))}
        </div>

        {/* Load More */}
        {hasMoreImages && (
          <div className="text-center mt-16">
            <button
              onClick={() => {
                setIsLoading(true);
                setTimeout(() => {
                  setVisibleCount((prev) => prev + 3);
                  setIsLoading(false);
                }, 400);
              }}
              className="px-10 py-4 rounded-full
              bg-gradient-to-r from-[#D4AF37] to-[#C9A631]
              text-[#07162E] font-semibold text-lg
              shadow-lg hover:shadow-[0_0_40px_rgba(212,175,55,0.45)]
              transition-all duration-300 hover:-translate-y-1"
            >
              {isLoading ? "Loading…" : "Load More Images"}
            </button>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {showLightbox && selectedImage !== null && (
        <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center">
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 p-3 text-white/80 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>

          <img
            src={displayedImages[selectedImage]}
            alt={`Summit ${selectedImage + 1}`}
            className="max-w-[90%] max-h-[85vh] object-contain rounded-lg"
          />
        </div>
      )}
    </section>
  );
}
